<template>
    <upload :id="id"
            ref="file_upload"
            :global="global"
            @filesToUpload="filesToUpload"
            @uploaded="handleUpload" />
</template>

<script>
import Upload from './fonts-upload.vue'

export default {
    props: ['id', 'global'],
    components: {
        Upload
    },
    methods: {
        handleUpload: function(data) {
            let json = jQuery.parseJSON(data)

            this.$emit('uploadedFile', json.data)
        },
        filesToUpload: function(count) {
            this.$emit('filesToUpload', count)
        }
    }
}
</script>
